import { Reducer } from "redux";
import IAlertsState from "./IAlertsState";
import { AlertsAction, AlertsActionTypes } from "./AlertsActions";

const initialState: IAlertsState = {
  alerts: [],
};

const AlertsReducer: Reducer<IAlertsState, AlertsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case AlertsActionTypes.SET_ALERTS: {
      return {
        ...state,
        alerts: [...action.data],
      };
    }
    case AlertsActionTypes.REMOVE_ALERT: {   
      return {
        ...state,
        alerts: [...state.alerts.filter(x=>x.alertId !== action.data)],
      };
    }
    default: {
      return state;
    }
  }
};

export default AlertsReducer;
